export const colors  = {
  text: 'black',
  background: 'white',
  main: '#0099CC',
  // main: 'blue',
}

